import type {
  Deal,
  Picker,
} from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { calculateReduction } from '@backmarket/utils/math/calculateReduction'

import { normalizePrice } from '../../helpers/normalizePrice/normalizePrice'

import translations from './applyDealToGradesGroup.translations'

export const applyDealToGradesGroup = (
  group: Picker,
  deal: Deal,
  i18n: ReturnType<typeof useI18n>,
): Picker => {
  const DEAL_TAGS = {
    flash_sales: {
      label: i18n(translations.flashSalesTag),
      type: 'success' as const,
    },
    seller_flash_sales: {
      label: i18n(translations.sellerFlashSalesTag),
      type: 'success' as const,
    },
  } as const

  if (!deal?.type || !(deal.type in DEAL_TAGS)) {
    return group
  }

  const dealTag = DEAL_TAGS[deal.type as keyof typeof DEAL_TAGS]

  return {
    ...group,
    items: group.items.map((item) => {
      if (!item.selected) return item

      const updatedItem = {
        ...item,
        tag: dealTag,
        dealType: deal.type,
      }

      if (deal.type === 'flash_sales' && item.price) {
        const normalizedDiscount = normalizePrice(deal.discount)

        const discountedPrice = calculateReduction(
          item.price,
          normalizedDiscount,
        )

        if (discountedPrice) {
          updatedItem.price = discountedPrice
        }
      }

      return updatedItem
    }),
  }
}
